import type { AccessLog } from '@/types';

// Where each resource type is managed (design eval F22): a resource in the log
// links to its own page, searched for by name.
export function resourcePageHref(type: string | undefined, name: string): string {
    const t = (type || '').toLowerCase();
    const base =
        t === 'ssh' ? '/ssh-resources'
        : t === 'k8s' ? '/k8s-resources'
        : t === 'database' ? '/databases'
        : t === 'desktop' ? '/desktop-resources'
        : t === 'http_proxy' ? '/proxy-resources'
        : t.startsWith('aws') ? '/cloud-providers/aws'
        : t.startsWith('azure') ? '/cloud-providers/azure'
        : t.startsWith('gcp') ? '/cloud-providers/gcp'
        : t.startsWith('hetzner') ? '/cloud-providers/hetzner'
        : '/resources';
    return name ? `${base}?q=${encodeURIComponent(name)}` : base;
}

/** The policy that decided an entry, when the entry names one. */
export function policyIdOf(log: AccessLog): string | undefined {
    const rec = log as AccessLog & { policy_id?: unknown };
    const id = rec.policy_id ?? log.response_metadata?.policy_id ?? log.request_context?.policy_id;
    return typeof id === 'string' && id ? id : undefined;
}

/** /policies opens a policy from ?open=<id> (pages/Policies.tsx). */
export const policyHref = (id: string) => `/policies?open=${encodeURIComponent(id)}`;
